import localforage from 'localforage';

/**
 * Drops the persisted redux store (IndexedDB "persist:root") right before the full
 * reload that switches identity — starting or stopping "view as".
 *
 * A reload alone is not enough: redux-persist rehydrates the previous identity's
 * records and permissions. PRQ-202600013 (2026-10-22): viewing as the Head of Finance
 * showed the admin's copy of the request, with the admin's permissions; the page asked
 * for the activity log the HoF may not see, and the whole page turned into a 403.
 * Signing in does not depend on it (tokens live in localStorage / cookies).
 */
const resetPersistedState = async (persistor) => {
  try {
    persistor?.pause();
    await persistor?.purge();
  } catch {
    /* fall through to the storage itself */
  }
  try {
    await localforage.removeItem('persist:root');
  } catch {
    /* storage unavailable — nothing persisted to leak either */
  }
};

export default resetPersistedState;
